/* eslint-disable */
import { Accordion, Container, Row, Col } from "react-bootstrap";

const dayjs = require("dayjs");
const relativeTime = require("dayjs/plugin/relativeTime");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
const advancedFormat = require("dayjs/plugin/advancedFormat");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);

const timeFormat = "h:mm A";

const dateFormat = "MM/DD/YYYY HH:mm A z";
const tz = "America/New_York";

function ReportingAccordion(props) {
  const outage = props.outage;

  let attendees =
    outage && outage.attendees ? outage.attendees.split("\n") : [];
  attendees = attendees.map((m) => {
    return `${m}`;
  });

  attendees ? (attendees = attendees.join(`\n`)) : "";

  // Generated by GitHub Copilot
  // Removed frontend sorting - backend already provides reverse chronological order via SortNotes()
  // Private notes must not leak into the Incident Report, which is copyable/shareable output
  const notes =
    outage && outage.notes
      ? outage.notes
          .filter((n) => !n.private)
          .map((n) => {
            const created = dayjs(n.created).tz(tz).format(dateFormat);
            const line = `${created} ${n.important ? " !! " : ""} ${n.message}`;
            return line;
          })
      : [];

  const noteString = notes ? notes.join("\n") : "";

  //   notes ? (notes = notes.join(`\n`)) : "";

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  const formatDateOrNone = (dateValue) => {
    if (!dateValue || dateValue === 0) {
      return "None";
    }
    return dayjs(dateValue).format(dateFormat);
  };

  const incidentStart = formatDateOrNone(outage?.incidentStart);
  const incidentEnd = formatDateOrNone(outage?.incidentEnd);
  const eocNotified = formatDateOrNone(outage?.eocNotified);
  const techTimeResolved = formatDateOrNone(outage?.techTimeResolved);
  const timeDetected = formatDateOrNone(outage?.timeDetected);

  const report = `Attendees
-----------
${attendees}

PIR Contact
-----------
${outage && outage.PIRContact}

Incident Commander
-----------
${outage && outage.incidentCommander}
    
Timeline
-----------
${noteString}
`;

  return (
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Incident Report</Accordion.Header>
        <Accordion.Body>
          <pre>{report}</pre>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>Outage Exec Description</Accordion.Header>
        <Accordion.Body>
          <div className="reporting-accordion">
            <Container>
              <Row>
                <Col>
                  <b>Current Status</b>
                </Col>
              </Row>
              <Row>
                <Col>{outage && outage.description}</Col>
              </Row>
              <Row>
                <Col>
                  <b>Incident Manager</b>
                </Col>
              </Row>
              <Row>
                <Col>{outage && outage.mim}</Col>
              </Row>
              <Row>
                <Col>
                  <b>Client Impact</b>
                </Col>
              </Row>
              <Row>
                <Col>{outage && outage.impact}</Col>
              </Row>
              <Row>
                <Col>
                  <b>Workaround</b>
                </Col>
              </Row>
              <Row>
                <Col>{outage && outage.workaround}</Col>
              </Row>
              <Row>
                <Col>
                  <b>Affected Users</b>
                </Col>
              </Row>
              <Row>
                <Col>{outage && outage.affectedUsers}</Col>
              </Row>
              <Row>
                <Col>
                  <b>Impact Begin</b>
                </Col>
              </Row>
              <Row>
                <Col>{incidentStart}</Col>
              </Row>
              <Row>
                <Col>
                  <b>Impact End</b>
                </Col>
              </Row>
              <Row>
                <Col>{incidentEnd}</Col>
              </Row>
              <Row>
                <Col>
                  <b>Time Detected</b>
                </Col>
              </Row>
              <Row>
                <Col>{timeDetected}</Col>
              </Row>
              <Row>
                <Col>
                  <b>Command Center Notified</b>
                </Col>
              </Row>
              <Row>
                <Col>{eocNotified}</Col>
              </Row>
              <Row>
                <Col>
                  <b>Time Resolved</b>
                </Col>
              </Row>
              <Row>
                <Col>{techTimeResolved}</Col>
              </Row>
              <Row>
                <Col>
                  <b>Technical Status</b>
                </Col>
              </Row>
              <Row>
                <Col>{outage && outage.technicalStatus}</Col>
              </Row>
              <Row>
                <Col>
                  <b>Slack Channel</b>
                </Col>
              </Row>
              <Row>
                <Col>{outage && outage.slackChannel}</Col>
              </Row>
            </Container>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export { ReportingAccordion };
